export const tripKinds = ['travel', 'any'];
